<template lang="pug">
  div#payment-agreement
    Header
    div.disclaimer
      div.text1 {{ pname }}用户付费协议
      div.text2 欢迎您使用{{ pname }}产品服务（以下或称“本产品”、“本服务”）！为了更好地使用相应的服务，也为保障您的权益，请您务必审慎阅读、充分理解《“{{ pname }}”用户付费协议》（以下简称“本协议”）所有内容。当您点击勾选“我已经阅读并同意《“{{ pname }}”用户付费协议》”按钮时，即表示您同意并承诺遵守本协议的全部约定。
      div.text2.bold 您确认，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力，确保有能力对您使用有驰声提供服务的一切行为独立承担责任。若您不具备前述主体资格或您是未满十八周岁的未成年人，请在您的监护人的陪同下阅读本服务条款，并在取得他们对您使用服务的行为，以及对本服务条款的同意之后，使用本服务；驰声在依据法律规定或本协议约定要求您承担责任时，有权向您的监护人追偿。
      div.text2.bold 第一条 定义
      div.text2 1、您：指注册账号并经{{ pname }}审核同意后，并使用{{ pname }}产品的用户。
      div.text2 2、{{pname}}（以下简称“驰声”）所有和经营的有关教育、学习等数字内容聚合、管理和分发的平台产品，旨在为机构及用户提供教学内容的生成、传播和学习等平台服务。
      div.text2 3、收费服务是指机构将测评、报告、文字、视频等内容发布至“驰声大学”平台并将其有偿提供给用户。
      div.text2.bold 第二条 本协议的修订
      div.text2.bold 驰声有权对本协议进行调整或补充，若您继续使用{{ pname }}，则视为您接受该等调整或补充，亦或您有权终止使用本服务。
      div.text2.bold 第三条 “{{ pname }}”规范
      div.text2 1、机构通过{{ pname }}为您提供有偿服务或内容（包括但不限于收费测评、收费报告、收费视频等所有收费类型的服务和内容，下同），驰声仅作为平台提供方，并非该等有偿服务或内容的提供方或售卖方。
      div.text2 2、{{ pname }}不参与用户与机构的交易。对于任何直接或间接的、实质或非实质的由于有偿服务或内容造成的损失或纠纷，将由用户与机构进行沟通处理，驰声将根据{{ pname }}平台的相关规则为您提供必要的客户服务。
      div.text2 3、除非另有证明，否则{{ pname }}储存在服务器上的数据将是您使用本产品的唯一有效证据。
      div.text2.bold 第四条 用户规则
      div.text2 1、您可浏览机构在{{ pname }}上发布的信息，并且您登录本产品时的帐号信息将是驰声确认您的身份的唯一依据。
      div.text2 您充分了解并同意，您必须为自己注册帐号下的一切行为负责，包括但不限于用户所发表的任何内容以及由此产生的任何后果。用户应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。
      div.text2.bold 2、您理解并同意：机构通过{{ pname }}平台提供有偿内容或服务实行先付款后使用的方式，及时、足额、合法地支付所需的款项是您使用该等有偿内容或服务的前提。
      div.text2.bold 3、您理解并同意：通过{{ pname }}平台购买收费服务后，在符合相关法律、法规规定的情况下，驰声有权根据上述规定对您购买的收费服务不予退款。
      div.text2.bold 4、您知悉并同意：您无权对已购买的服务进行出售、转让、许可或以其他任何方式使除您自己以外的第三方（包括但不限于自然人、法人或其他组织）使用您已购买的服务。若您违反本条规定，则驰声有权视情况采取如下措施：
      div.text2.bold 4.1 取消您继续使用该服务的权利；
      div.text2.bold 4.2 限制/冻结您的帐号；
      div.text2.bold 4.3 要求您退还通过出售、转让、许可等方式取得的所有收益；
      div.text2.bold 4.4  其他驰声可以采取的救济措施。
      div.text2.bold 5、您理解并同意：{{ pname }}可能会基于自身原因（包括但不限于：更新服务内容、改进服务安排）不定期地对收费服务进行更新而无需经过您的事先同意。
      div.text2 6、{{ pname }}支持通过第三方交易平台进行款项支付，该等支付服务的使用条件及规范由您与支付服务提供方确定，与{{ pname }}无关，您需要自行承担交易所产生的法律后果。
      div.text2 7、在您下订单时，请您仔细确认所购内容、服务的名称、价格、有效期等信息，并对您的行为及意思表示的法律后果承担责任。
      div.text2.bold 8、您理解并同意：本平台上的内容、服务和价格等信息仅仅是要约邀请，您下单时需确认您希望购买的内容、服务的价款及支付方式、收货账号、用户名等内容，您下单并支付货款后合同即成立。
      div.text2.bold 9、您应当妥善保管自己的账号和密码，如因您自身的原因（包括但不限于转让账号、与他人共用账号、自己泄露而导致账号等）或您所使用的计算机或其他终端产品感染病毒或木马，而导致账号、密码泄漏、遗失，所造成的一切损失将由您自行承担，若给{{ pname }}或第三方造成损害的，您需负全部责任。另外，您还需对用户账号中的所有活动和事件负全责。您可随时修改账号和密码。您同意若发现非法使用用户账号或出现安全漏洞的情况，将立即通告{{ pname }}，{{ pname }}将会尽力予以妥善解决。
      div.text2.bold 第五条  其他约定
      div.text2 1、所有权及知识产权：{{ pname }}平台上所有内容，包括但不限于文字、软件、声音、图片、视频、图表、网站架构、网站画面的安排、网页设计、以及有偿内容或服务均由驰声、机构或其他权利人依法享有知识产权，包括但不限于著作权、商标权、专利权等。非经{{ pname }}、机构或其他权利人书面同意不得擅自使用、修改、复制、传播、改变、散布、发行或发表上述内容。如有违反，您同意承担由此给{{ pname }}、驰声、机构或其他权利人造成的一切损失。
      div.text2 2、通知：驰声可通过电子邮件、常规的信件或在网站显著位置公告的方式向您发送公告或通知。
      div.text2 3、本协议适用中华人民共和国的法律（不含冲突法）。当本协议的任何内容与中华人民共和国法律、法规相抵触时，应当以法律、法规规定为准，同时相关内容将按法律、法规的规定进行修改或重新解释，而本协议其他部分的法律效力不变。
      div.text2.bold 4、凡因本协议引起的或与本协议有关的任何争议，均应提交苏州市工业园区人民法院诉讼解决。
      div.text2 5、本协议自发布之日起实施，并构成您和{{ pname }}之间的共识。
      div.text2 6、{{ pname }}不行使、未能及时行使或者未充分行使本协议或者按照法律、法规规定所享有的权利，不应被视为放弃该权利，也不影响{{ pname }}在将来行使该权利。
      div.text2 7、{{ pname }}已经发布的或将来可能发布的各类规则均为本协议不可分割的组成部分，与本协议具有同等法律效力。
      div.text2 8、如果您对本协议内容有任何疑问，请联系客服，联系方式：400-018-9011。
      div.text2.bold 温馨提示：购买时请确认产品功能及费用，鉴于产品属性，一旦购买将不予退款。
    Footer
</template>

<script>
/**
 * 付费协议
 */
import Header from './Stu/header'
import Footer from './Stu/footer'

export default {
  name: 'PaymentAgreement',
  components: { Header, Footer },
  data() {
    return {
      pname: window.ConfigNew.header.name
    }
  }
}
</script>

<style lang="less">
#payment-agreement {
  .stu-header {
    .linkArea {
      display: none !important;
    }
  }

  .disclaimer {
    width: 1180px;
    padding: 50px 125px 90px;
    margin: 20px auto 30px;
    background-color: #fff;

    .text1 {
      margin-bottom: 60px;
      color: #333;
      font-size: 30px;
      font-weight: bold;
      text-align: center;
      line-height: 40px;
    }

    .text2 {
      margin-bottom: 35px;
      color: #666;
      font-size: 16px;
      line-height: 36px;
    }
    .bold {
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PaymentAgreement.vue